<template>
    <div class="container layout complete" :class="{'is-norange': !range.init}">

        <top title="Paylaşımın için teşekkürler!" :center="true" logo-type="white" sizeClass="is-full"></top>

        <div class="columns is-marginless" :class="{'is-centered': !range.init}">

            <div class="column is-7" v-if="range.init">
                <div class="box has-text-centered">
                    <h4 class="is-uppercase has-text-primary is-size-4">{{position.name}} Maaş Bilgisi</h4>
                    <p class="is-size-5 is-size-6-mobile has-text-nightbluelight">Paylaştığın bilgilerle <span class="is-lowercase">{{position.name}}</span> pozisyonundaki maaş bilgisini güncelledik.</p>
                    <avarage :min="range.minPrice" :center="range.averagePrice" :max="range.maxPrice"></avarage>
                </div>
            </div>

            <div class="column" :class="{'is-7': !range.init}" v-if="existLoaded">

                <div class="box has-text-centered" v-if="completeType == 1">
                    <h4 class="is-size-4 is-size-5-mobile has-text-word-break">Başka şirketler için de maaş bilgisi veya mülakat deneyimi paylaşmak ister misin?</h4>
                    <div class="buttons is-block">
                        <router-link class="button is-primary is-fullwidth has-text-weight-semibold is-size-8 is-uppercase" :to="{name: 'Main'}">Evet, İsterim</router-link>
                        <router-link class="button is-white has-text-info is-fullwidth has-text-weight-semibold is-size-8 is-text-button" :to="{name: 'Main'}">Hayır, istemem</router-link>
                    </div>
                </div>

                <div class="box has-text-centered" v-if="completeType == 2">
                    <h4 class="is-size-4 is-size-5-mobile has-text-word-break">Şimdi de {{company.companyName}} için mülakat bilgisi paylaşmak ister misin?</h4>
                    <div class="buttons is-block">
                        <router-link class="button is-primary is-fullwidth has-text-weight-semibold is-size-8 is-uppercase" :to="{name: 'Interview'}">Evet, İsterim</router-link>
                        <router-link class="button is-white has-text-info is-fullwidth has-text-weight-semibold is-size-8 is-text-button" :to="{name: 'Main'}">Hayır, istemem</router-link>
                    </div>
                </div>

                <div class="box has-text-centered" v-if="completeType == 3">
                    <h4 class="is-size-4 is-size-5-mobile has-text-word-break">Şimdi de {{company.companyName}} için maaş bilgisi paylaşmak ister misin?</h4>
                    <div class="buttons is-block">
                        <router-link class="button is-primary is-fullwidth has-text-weight-semibold is-size-8 is-uppercase" :to="{name: 'Salary'}">Evet, İsterim</router-link>
                        <router-link class="button is-white has-text-info is-fullwidth has-text-weight-semibold is-size-8 is-text-button" :to="{name: 'Main'}">Hayır, istemem</router-link>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
    import apiConfigs from '@/services/config'
    import top from  '@/components/Top'
    import avarage from  '@/components/Avarage'

    export default {
        name: "Complete",
        data(){
            return {
                company  : {
                    companyName: null
                },
                position : {
                    id : null,
                    name: null
                },
                userCompanySalary: [],
                userCompanyInterview: [],
                interviewExist : null,
                salaryExist: null,
                existLoaded: false,
                range:{
                    init     : false,
                    minPrice : null,
                    maxPrice : null,
                    averagePrice: null
                }
            }
        },
        computed: {
            completeType: function() {
                if (this.interviewExist || this.salaryExist)
                {
                    dataLayer.push({'kart_tipi':"yeni"});
                    return 1
                }
                else if (!this.interviewExist && this.$route.params.type === 'salary')
                {
                    dataLayer.push({'kart_tipi':"mulakat"});
                    return 2
                }
                else if (!this.salaryExist &&  this.$route.params.type === 'interview')
                {
                    dataLayer.push({'kart_tipi':"maas"});
                    return 3
                }
                else
                    return null
            }
        },
        methods:{
            getRange(){
                apiConfigs.serviceWrapper(apiConfigs.serviceConfigs.salary, apiConfigs.serviceConfigs.salary.range, {positionId : this.position.id, errorMessage: false})
                    .then((response) => {
                        
                        let data = response.data;
                        if (data.statusCode == 200) {
                            this.range = data.result
                            this.range.init = true
                        }
                    })
                    .catch(() => {
                        this.range.init = false
                    })
            },

            getExistService(type){

                let params = {
                    companyId : this.company.companyId,
                    companyName: this.company.companyName,
                    positionId: this.position.id
                }

                apiConfigs.serviceWrapper(apiConfigs.serviceConfigs.user, apiConfigs.serviceConfigs.user[type], params)
                    .then((response) => {
                        let data = response.data;
                        if (data.statusCode == 200) {
                                type === 'salary' ? this.salaryExist = data.result.isExist : this.interviewExist = data.result.isExist;
                        }
                        this.existLoaded = true;
                    })
            }

            // getExistService(type){

            //     if (type === 'salary' && localStorage && localStorage.userCompanySalary)
            //     {
            //         this.userCompanySalary = JSON.parse(localStorage.userCompanySalary)
            //         this.salaryExist = this.filterUserCompany(this.userCompanySalary)
            //     }
            //     else if (type === 'interview' && localStorage && localStorage.userCompanyInterview)
            //     {
            //         this.userCompanyInterview = JSON.parse(localStorage.userCompanyInterview)
            //         this.interviewExist = this.filterUserCompany(this.userCompanyInterview)
            //     }
                
            //     this.setUserLocalStorage(type, { companyId : this.company.companyId, positionId: this.position.id })

            //     this.existLoaded = true;
            // },

            // filterUserCompany(userData)
            // {
                
            //     return userData.filter(
            //                 uC =>
            //                 uC.companyId == this.company.companyId &&
            //                 uC.positionId == this.position.id
            //             ).length > 0;
            // },

            // setUserLocalStorage(type, data)
            // {
            //     if (type === 'salary' && !this.salaryExist)
            //     {
            //         this.userCompanySalary.push(data)
            //         localStorage.setItem('userCompanySalary', JSON.stringify(this.userCompanySalary))
            //     }
            //     else if (type === 'interview' && !this.interviewExist)
            //     {
            //         this.userCompanyInterview.push(data)
            //         localStorage.setItem('userCompanyInterview', JSON.stringify(this.userCompanyInterview))
            //     }  
            // }
        },
        components:{top,avarage},
        created(){

            if (sessionStorage && sessionStorage.userCompany) this.company = JSON.parse(sessionStorage.userCompany)
            if (sessionStorage && sessionStorage.userPosition) this.position = JSON.parse(sessionStorage.userPosition)

            if(this.$route.params.type !== 'salary' && this.$route.params.type !== 'interview'){
                this.$router.push({name: 'Main'})
                return false
            }

            if(!this.position.id){
                this.$router.push({name: 'Main'})
                return false
            }

            if (this.$route.params.type === 'salary'){
                this.getRange()
                this.getExistService('interview')
            }else{
                this.getExistService('salary')
            }
        }
    }
</script>